const ACCESS_TOKEN_KEY = 'flintpay_access_token';
const REFRESH_TOKEN_KEY = 'flintpay_refresh_token';

export const getAccessToken = (): string | null => {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
};

export const clearSession = (): void => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
};

export const saveSessionTokens = (params: { accessToken?: string | null; refreshToken?: string | null }): void => {
  if (params.accessToken) {
    localStorage.setItem(ACCESS_TOKEN_KEY, params.accessToken);
  }

  if (params.refreshToken) {
    localStorage.setItem(REFRESH_TOKEN_KEY, params.refreshToken);
  }
};

export const saveSessionFromOAuthCallback = (): { saved: boolean; error?: string } => {
  const hash = new URLSearchParams(window.location.hash.replace(/^#/, ''));
  const query = new URLSearchParams(window.location.search);

  const error = hash.get('error_description') || hash.get('error') || query.get('error_description') || query.get('error');
  if (error) {
    return { saved: false, error };
  }

  const accessToken = hash.get('access_token');
  const refreshToken = hash.get('refresh_token');

  if (!accessToken) {
    return { saved: false, error: 'Missing access token in OAuth callback.' };
  }

  saveSessionTokens({ accessToken, refreshToken });
  return { saved: true };
};

const decodeJwtPayload = (token: string): Record<string, unknown> | null => {
  try {
    const parts = token.split('.');
    if (parts.length < 2) return null;
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = payload + '='.repeat((4 - (payload.length % 4)) % 4);
    const decoded = atob(padded);
    return JSON.parse(decoded) as Record<string, unknown>;
  } catch (_) {
    return null;
  }
};

export const getRoleFromAccessToken = (token?: string | null): string | null => {
  const resolvedToken = token || getAccessToken();
  if (!resolvedToken) return null;

  const payload = decodeJwtPayload(resolvedToken);
  if (!payload) return null;

  const appMetadata = payload.app_metadata as Record<string, unknown> | undefined;
  const userMetadata = payload.user_metadata as Record<string, unknown> | undefined;

  const role =
    (appMetadata?.role as string | undefined) ||
    (userMetadata?.role as string | undefined) ||
    null;

  return role;
};

export const getDashboardRouteForRole = (role?: string | null): string => {
  switch ((role || '').toLowerCase()) {
    case 'admin':
      return '/admin/control-tower';
    case 'manager':
    case 'finance':
      return '/manager/dashboard';
    default:
      return '/employee/dashboard';
  }
};
